import api from '../library/axios';

export default {
  getCustomFeature(company_id, workspace_id) {
    return api({
      method: 'get',
      url: `/api/custom-features/${company_id}/${workspace_id}`,
    });
  },
};
